import React from 'react';
import PageHero from '../components/PageHero';
import WhyChooseUs from '../components/WhyChooseUs';
import FinalCTA from '../components/FinalCTA';
import { Package, ShieldCheck, ShoppingBag } from 'lucide-react';
import RevealOnScroll from '../components/RevealOnScroll';

const ServicesPage: React.FC = () => {
    return (
        <>
            <PageHero
                title="Our Services"
                subtitle="Everything you need for smooth Sri Lanka to Maldives shipping."
            />

            {/* Detailed Services Section */}
            <section className="py-12 md:py-20 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid md:grid-cols-2 gap-6 md:gap-8 lg:gap-12">

                        <RevealOnScroll className="bg-brand-50 rounded-3xl p-6 md:p-8 flex flex-col md:flex-row gap-4 md:gap-6 items-start">
                            <div className="bg-brand-600 text-white p-3 md:p-4 rounded-xl shrink-0">
                                <MapPinIcon className="w-6 h-6 md:w-8 md:h-8" />
                            </div>
                            <div>
                                <h3 className="text-lg md:text-xl font-bold text-slate-900 mb-2">Sri Lankan Shopping Address</h3>
                                <p className="text-slate-600 leading-relaxed mb-4 text-sm md:text-base">
                                    Get your own personal suite number and address in Colombo immediately upon signup. Use this address for all your online shopping.
                                </p>
                                <button className="text-brand-600 font-bold text-xs md:text-sm uppercase tracking-wide hover:underline">Get Address →</button>
                            </div>
                        </RevealOnScroll>

                        <RevealOnScroll delay={100} className="bg-brand-50 rounded-3xl p-6 md:p-8 flex flex-col md:flex-row gap-4 md:gap-6 items-start">
                            <div className="bg-brand-600 text-white p-3 md:p-4 rounded-xl shrink-0">
                                <Package className="w-6 h-6 md:w-8 md:h-8" />
                            </div>
                            <div>
                                <h3 className="text-lg md:text-xl font-bold text-slate-900 mb-2">Package Consolidation</h3>
                                <p className="text-slate-600 leading-relaxed mb-4 text-sm md:text-base">
                                    Shop from multiple stores? We combine all your boxes into one shipment, removing unnecessary packaging to save you up to 80% on shipping costs.
                                </p>
                                <button className="text-brand-600 font-bold text-xs md:text-sm uppercase tracking-wide hover:underline">Learn More →</button>
                            </div>
                        </RevealOnScroll>

                        <RevealOnScroll delay={200} className="bg-brand-50 rounded-3xl p-6 md:p-8 flex flex-col md:flex-row gap-4 md:gap-6 items-start">
                            <div className="bg-brand-600 text-white p-3 md:p-4 rounded-xl shrink-0">
                                <ShieldCheck className="w-6 h-6 md:w-8 md:h-8" />
                            </div>
                            <div>
                                <h3 className="text-lg md:text-xl font-bold text-slate-900 mb-2">30 Days Free Storage</h3>
                                <p className="text-slate-600 leading-relaxed mb-4 text-sm md:text-base">
                                    Need time to shop? We store your packages securely in our Colombo warehouse for up to 30 days, absolutely free.
                                </p>
                            </div>
                        </RevealOnScroll>

                        <RevealOnScroll delay={300} className="bg-brand-50 rounded-3xl p-6 md:p-8 flex flex-col md:flex-row gap-4 md:gap-6 items-start">
                            <div className="bg-brand-600 text-white p-3 md:p-4 rounded-xl shrink-0">
                                <ShoppingBag className="w-6 h-6 md:w-8 md:h-8" />
                            </div>
                            <div>
                                <h3 className="text-lg md:text-xl font-bold text-slate-900 mb-2">Repacking Services</h3>
                                <p className="text-slate-600 leading-relaxed mb-4 text-sm md:text-base">
                                    We ensure your items are packed securely for international travel. We add protective materials to fragile items.
                                </p>
                            </div>
                        </RevealOnScroll>

                    </div>
                </div>
            </section>

            <WhyChooseUs />
            <FinalCTA />
        </>
    );
};

// Helper Icon for the component
function MapPinIcon({ className }: { className?: string }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" /><circle cx="12" cy="10" r="3" /></svg>
    )
}

export default ServicesPage;